import {Icon, Popup} from 'semantic-ui-react';
import PropTypes from 'prop-types';

export default function InformationTip({children}) {
  return (
    <Popup on="click" wide
           position="right center"
           trigger={<Icon name="help circle outline" link/>}>
      {children}
    </Popup>
  );
}

InformationTip.propTypes = {
  children: PropTypes.node,
};